import * as React from "react";
import { QueryStatus, skipToken } from "@reduxjs/toolkit/query";
import { EXPERIENCE } from "../../constants";
import { getAccountInfo } from "../../services/savvy";
import useAppSelector from "../../hooks/useAppSelector";
import useInitialRoute from "./useInitialRoute";
import { useLocation } from "react-router-dom";
import useMemoryHistory from "../../hooks/useMemoryHistory";
export default function NavigationProvider(_a) {
    var children = _a.children;
    var initialRoute = useInitialRoute();
    var history = useMemoryHistory();
    var hasInitialRoute = useAppSelector(function (state) { return state.navigation.entries.length > 0; });
    var featureFlagsLoaded = useAppSelector(function (state) { return state.featureFlags.status === QueryStatus.fulfilled; });
    var location = useLocation();
    var isPrefill = useAppSelector(function (state) { return state.configuration.experience === EXPERIENCE.PREFILL; });
    var accountReferenceId = useAppSelector(function (state) { return state.applicant.accountReferenceId; });
    var status = getAccountInfo.useQueryState(accountReferenceId || skipToken).status;
    var didPrefill = useAppSelector(function (state) {
        return (state.unlinkedApplication.prefill.auto.data &&
            state.unlinkedApplication.prefill.auto.issuer) ||
            (state.unlinkedApplication.prefill.home.data &&
                state.unlinkedApplication.prefill.home.issuer);
    });
    var prefillDataLoaded = isPrefill
        ? status === QueryStatus.fulfilled && didPrefill
        : true;
    var shouldGetInitialRoute = featureFlagsLoaded &&
        Boolean(initialRoute) &&
        prefillDataLoaded &&
        (location.pathname === "/" || !hasInitialRoute);
    React.useEffect(function () {
        if (shouldGetInitialRoute) {
            history.push(initialRoute);
        }
    }, [shouldGetInitialRoute, initialRoute, history]);
    return React.createElement(React.Fragment, null, children);
}
